const adaptData = ({ sections }, location) => {
    const { pathname } = location;
    const parts = pathname.split('/').filter(part => part != '');
    const currentSection = parts[1];

    const sectionLinks = sections.map(section => ({ href: `/sitemap/${section.toLowerCase()}/0`, text: section }))

    return {
        sections: sectionLinks,
        currentSection
    }
};

export default adaptData;
